import React, { useContext } from "react";
import "./Our_Achievements.css";
import { Context } from "../../../utils/context";

const Our_Achievements = () => {


  const {
    IMG_URL,
    appSetup
  } = useContext(Context);


  const stats = [
    {
      icon: "/assets/images/home/our_achievements/icon-1.png",
      title: "Experience",
      value: `${appSetup?.total_experience || "10"}+ years`,
    },
    {
      icon: "/assets/images/home/our_achievements/icon-2.png",
      title: "Happy Clients",
      value: `${appSetup?.happy_clients || "1000"}+`,
    },
    {
      icon: "/assets/images/home/our_achievements/icon-3.png",
      title: "Trips Completed",
      value: `${appSetup?.trip_completed || "1000"}+`,
    },
  ];
  return (
    <section className="Our_Achievements">
      <div className="container">
        <div className="Our_Achievements_banner_div">
          <div className="Our_Achievement_heading_holder">
            <div className="row align-items-center justify-content-center mb-3">
              <div className="col-lg-5 col-md-4">
                <h4 className="Achievement">Our Achievement</h4>
              </div>

              <div className="col-lg-6 col-md-7">
                <p className="Achievement_text">
                  Our Milestones & Achievements At Infinity Ladakh Taxi, we
                  measure our success by the miles we cover and the smiles we
                  leave behind. Over the years, we’ve transformed from a local
                  fleet into one of the most trusted names in Himalayan travel.
                </p>
              </div>
            </div>
          </div>

          <div className="achievement_row">
            <div className="row align-items-center justify-content-center mt-5">
              {stats.map((item, index) => (
                <div className="col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                  <div className="achievement_box">
                    <div className="achievement_icon_holder">
                      <img src={item.icon} alt="icons" className="achievement_icon" />
                    </div>
                    <div className="achievement_holder">
                      <h6 className="achievement_title">{item.title}</h6>
                      <h3 className="achievement_value">{item.value}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Our_Achievements;
